import { useParams, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft, Clock, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import { blogPosts } from '@/data/blogPosts';

export default function BlogPost() {
  const { postId } = useParams();
  const post = blogPosts.find(p => p.id === postId);

  if (!post) {
    return (
      <div className="min-h-screen bg-white">
        <Navbar />
        <div className="pt-24 pb-16 text-center">
          <h1 className="text-2xl font-bold text-slate-900">Post not found</h1>
          <Link to="/blog" className="text-amber-600 mt-4 inline-block">Back to Blog</Link>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <article className="pt-24 pb-16">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link to="/blog" className="inline-flex items-center gap-2 text-amber-600 hover:text-amber-700 mb-8 text-sm" data-testid="back-to-blog">
            <ArrowLeft className="w-4 h-4" /> Back to Blog
          </Link>

          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
            <span className="inline-block bg-amber-100 text-amber-700 text-xs font-medium px-3 py-1 rounded-full mb-4">
              {post.category}
            </span>
            <h1 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-4" data-testid="blog-post-title">
              {post.title}
            </h1>
            <div className="flex items-center gap-4 text-sm text-slate-500 mb-10">
              <span className="flex items-center gap-1"><Clock className="w-4 h-4" /> {post.readTime}</span>
              <span>{new Date(post.date).toLocaleDateString('en-IN', { day: 'numeric', month: 'long', year: 'numeric' })}</span>
            </div>

            <div className="prose prose-slate max-w-none">
              {post.content.map((section, i) => (
                <div key={i} className="mb-8">
                  <h2 className="text-xl font-bold text-slate-900 mb-3">{section.heading}</h2>
                  {section.text.split('\n\n').map((para, j) => (
                    <p key={j} className="text-slate-600 leading-relaxed mb-3 whitespace-pre-line">{para}</p>
                  ))}
                </div>
              ))}
            </div>

            {/* CTA */}
            <div className="mt-12 p-8 bg-slate-900 rounded-2xl text-center">
              <h3 className="text-2xl font-bold text-white mb-3">Ready to start saving?</h3>
              <p className="text-slate-300 mb-6">Get a customized flight subscription plan for your route</p>
              <Link to="/subscription-plans" data-testid="blog-cta-btn">
                <Button className="rounded-full bg-amber-600 hover:bg-amber-700 text-white px-8 py-5 text-lg">
                  Get Your Custom Plan <ArrowRight className="ml-2 w-5 h-5" />
                </Button>
              </Link>
            </div>
          </motion.div>
        </div>
      </article>

      <Footer />
    </div>
  );
}
